module.exports = __webpack_public_path__ + "static/media/ContactCloudBanner.00d28311.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-screen/ContactCloudBanner.svg
// module id = 636
// module chunks = 0